export const API_SET_CONFIGURATION = "API_SET_CONFIGURATION";
export const API_SET_APPLICATION_DATA ="API_SET_APPLICATION_DATA";
export const API_SUBMIT_APPLICATION ="API_SUBMIT_APPLICATION";